<template>
  <multi-selection-tool-button
    icon="delete"
    :disabled="
      disabled ||
        (nrObjectsSelected && nrObjectsSelected === 0) ||
        !canUseTool('destroy')
    "
    :tooltip="$t('DeleteSelected')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";
import { multiSelectionToolsMixin } from "@/mixins/forms/multipleObjectsSelection/multiSelectionToolsMixin";

export default {
  name: "HomeFormTableDeleteTool",

  components: { MultiSelectionToolButton },

  mixins: [multiSelectionToolsMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    nrObjectsSelected: {
      type: Number
    },

    permission: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/Delete.vue